import React, { useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
  SIDEBAR_OPTIONS,
} from "../../shared/enums/reviewstatuss_enum";
import SingleView from "../../components/common/SingleView";
import { useSingleReviewstatus } from "../../shared/hooks/UseReviewstatus";
const ViewReviewstatus = ({ match }) => {
  const [data] = useSingleReviewstatus(match.params.id);
  const { reviewstatus_loading, reviewstatus } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!reviewstatus_loading ? (
          reviewstatus && (
            <SingleView
              data={reviewstatus}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={reviewstatus._id}
              SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewReviewstatus;
